export function isOrgMembershipRoleKey(roleKey?: string | null): boolean {
  return /^mo\d{6}$/i.test(roleKey ?? '')
}

export function isServiceAccessGroup(roleKey?: string | null): boolean {
  if (!roleKey) return false
  return isOrgMembershipRoleKey(roleKey) || roleKey === 'medcifra_admin'
}
